import React from "react";
import Login from "../Component/ClubLoginComponent/Login";
import CreateAccount from "../Component/ClubLoginComponent/CreateAccount";
import FormLayout from "../pages/Layout/form layout/FormLayout";
import golfreg from "../../assets/playing-golf_016o.svg";


const ClubLogin = () => {
  return (
    <section className="section-p bg-color-w">

      <div className="page-width">
       
          <FormLayout heading="Club Log in">
            <div className="login__wrapper-block">
              <Login />
              <div className="login-reg-right">
                <img src={golfreg} alt="Golf Registration" />
                <CreateAccount />
              </div>
            </div>
          </FormLayout>
     
      </div>
    </section>
  );
};

export default ClubLogin;
